"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Dashboard = void 0;
const types_1 = require("../../types");
const store_1 = require("../../exports/store");
const command_manager_1 = require("../../command_manager");
const commands_1 = require("../../commands");
class Dashboard {
    /**
     * Create a `Dashboard` instance.
     *
     * @deprecated This constructor is not intended for public use.
     */
    constructor(id, options) {
        this.id = id;
        this.type = types_1.ResourceType.Dashboard;
        const { store, saver, commandManager, widgetMap } = options;
        this.store = store;
        this.saver = saver;
        this._commandManager = commandManager;
        this.widgetMap = widgetMap;
    }
    /**
     * The name of this dashboard.
     */
    get name() {
        return store_1.Selectors.getDashboard(this.store.getState(), this.id).name;
    }
    get revision() {
        return store_1.Selectors.getResourceRevision(this.store.getState(), this.id, types_1.ResourceType.Dashboard);
    }
    setWidgetInstalled(widget) {
        this.store.dispatch(store_1.StoreActions.receiveInstallationWidget(widget.id, widget));
    }
    /**
     * Perform a command on this dashboard.
     *
     * @param command The command that will be executed.
     * @param saveOptions The options that will be passed to the data saver.
     *
     * @deprecated This method is not intended for public use.
     */
    doCommand(command, saveOptions) {
        return __awaiter(this, void 0, void 0, function* () {
            const result = this._commandManager.execute(command);
            if (result.result === command_manager_1.ExecuteResult.Success) {
                const saveResult = yield this.saver.saveOps(result.resourceOpsCollects, Object.assign(Object.assign({}, saveOptions), { resource: this, store: this.store }));
                result['saveResult'] = saveResult;
            }
            return result;
        });
    }
    /**
     * Add widgets to the dashboard.
     *
     * @param saveOptions The options that will be passed to the data saver.
     */
    addWidgets(widgetIds, saveOptions) {
        return this.doCommand({
            cmd: commands_1.CollaCommandName.AddWidgetToDashboard,
            dashboardId: this.id,
            widgetIds,
        }, saveOptions);
    }
    /**
     * Add widgets to the dashboard.
     *
     * @param saveOptions The options that will be passed to the data saver.
     */
    setWidgetDependencyDatasheet(options, saveOptions) {
        return this.doCommand({
            cmd: commands_1.CollaCommandName.SetWidgetDepDstId,
            resourceId: options.widgetId,
            resourceType: types_1.ResourceType.Widget,
            dstId: options.dstId,
        }, saveOptions);
    }
    /**
     * Delete a widget from the dashboard.
     *
     * @param saveOptions The options that will be passed to the data saver.
     */
    deleteWidget(widgetId, saveOptions) {
        return this.doCommand({
            cmd: commands_1.CollaCommandName.DeleteDashboardWidget,
            dashboardId: this.id,
            widgetId,
        }, saveOptions);
    }
}
exports.Dashboard = Dashboard;
//# sourceMappingURL=dashboard.js.map